import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Converts a string to a filename-safe slug: lowercased, with any run of
 * non-alphanumeric characters collapsed to a single hyphen and leading/trailing
 * hyphens trimmed. e.g. "Custodian Cut Off Time" -> "custodian-cut-off-time".
 */
export function slugify(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
